import { Box } from '@mui/material';
import AssetItemDetails from './AssetItem/AssetItemDetails';
import AssetItemChart from './AssetItem/AssetItemChart';
import type { productionAsset } from 'types/production.types';
import useAppTheme from 'hooks/useAppTheme';
import { CLIENT_THEME, clientThemePalette } from 'utils/clientTheme';

interface Props {
  data: productionAsset;
  selectedSource: string;
  aggregation: string;
}

const AssetItem = ({ data, selectedSource, aggregation }: Props) => {
  const { enableDarkTheme } = useAppTheme();
  const palette = enableDarkTheme
    ? clientThemePalette[CLIENT_THEME].dark
    : clientThemePalette[CLIENT_THEME].light;
  return (
    <Box
      sx={{
        backgroundColor: enableDarkTheme
          ? palette.paperBackground
          : palette.toolBarBackground,
        border: `1px solid ${palette.cardBorderColor}`,
        padding: '16px',
        borderRadius: '8px',
        marginBottom: '10px',
      }}
      data-attribute="assetItemBox"
    >
      <AssetItemDetails data={data} />
      <AssetItemChart
        data={data}
        selectedSource={selectedSource}
        aggregation={aggregation}
      />
    </Box>
  );
};

export default AssetItem;
